export default __webpack_public_path__ + "assets/food.31c540.png";